define.alias("ember-cli-string-helpers/helpers/titleize", "preview-grid/helpers/titleize");